import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';

class PromotionDropdowns extends Component {
    state = {
        boardId: null,
        classId: null,
        sectionId: null,

        boards: [],
        classes: [],
        sections: [],

        // Store selected items for easy access
        selectedBoard: null,
        selectedClass: null,
        selectedSection: null,

        loading: false
    };

    componentDidMount() {
        if (this.props.academicYear) {
            this.loadDataForAcademicYear();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.academicYear && this.props.academicYear !== prevProps.academicYear) {
            this.loadDataForAcademicYear();
        }
    }

    loadDataForAcademicYear = async () => {
        if (!this.props.academicYear) return;

        this.setState({ loading: true });

        try {
            // Load boards for the selected academic year and branchId
            const boardUrl = `${baseUrlAdmin}/organization?academicYear=${this.props.academicYear}&branchId=${this.props.currentBranchId}`;
            const boardResponse = await new Service().get(boardUrl, true);

            if (boardResponse?.status && boardResponse?.res?.Item) {
                const boardsData = this.processBoardsData(boardResponse.res.Item);
                this.setState({ boards: boardsData });
            }

        } catch (error) {
            console.error('Error loading data for academic year:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    processBoardsData = (response) => {
        let boards = JSON.parse(JSON.stringify(response));
        let activeBoards = [];

        for (let board of boards) {
            if (board.boardActivity && board.classes) {
                const activeClasses = board.classes.filter(cls => cls.isActivity);
                if (activeClasses.length > 0) {
                    activeBoards.push({
                        ...board,
                        label: board.boardName,
                        value: board.boardId,
                        classes: activeClasses
                    });
                }
            }
        }

        return activeBoards;
    };

    onBoardChange = (boardId) => {
        const selectedBoard = this.state.boards.find(board => board.value === boardId);

        let availableClasses = [];
        if (selectedBoard && selectedBoard.classes) {
            availableClasses = selectedBoard.classes.map(cls => ({
                label: cls.className,
                value: cls.classId,
                ...cls
            }));
        }

        this.setState({
            boardId,
            classId: null,
            sectionId: null,
            classes: availableClasses,
            sections: [],
            selectedBoard,
            selectedClass: null,
            selectedSection: null
        });

        this.notifyParent();
    };

    onClassChange = (classId) => {
        const selectedClass = this.state.classes.find(cls => cls.value === classId);

        let availableSections = [];
        if (selectedClass && selectedClass.sections) {
            // Filter sections by branchId if available
            availableSections = selectedClass.sections
                .filter(section => {
                    // If branchId is available in section data, filter by it
                    // Otherwise, include all sections (fallback behavior)
                    return !section.branchId || section.branchId === this.props.currentBranchId;
                })
                .map(section => ({
                    label: section.sectionName,
                    value: section.sectionId,
                    ...section
                }));
        }

        this.setState({
            classId,
            sectionId: null,
            sections: availableSections,
            selectedClass,
            selectedSection: null
        });

        this.notifyParent();
    };

    onSectionChange = (sectionId) => {
        const selectedSection = this.state.sections.find(section => section.value === sectionId);

        this.setState({
            sectionId,
            selectedSection
        });
        this.notifyParent();
    };

    notifyParent = () => {
        setTimeout(() => {
            if (this.props.setValues) {
                this.props.setValues({
                    boardId: this.state.boardId,
                    classId: this.state.classId,
                    sectionId: this.state.sectionId,
                    boardIds: this.state.boardId ? [this.state.boardId] : [],
                    classIds: this.state.classId ? [this.state.classId] : [],
                    sectionIds: this.state.sectionId ? [this.state.sectionId] : [],
                    // Include selected objects for easy access
                    selectedBoard: this.state.selectedBoard,
                    selectedClass: this.state.selectedClass,
                    selectedSection: this.state.selectedSection
                });
            }
        }, 0);
    };

    // Method to get current selections (for parent access)
    getSelections = () => ({
        selectedBoard: this.state.selectedBoard,
        selectedClass: this.state.selectedClass,
        selectedSection: this.state.selectedSection
    });

    render() {
        const { boardId, classId, sectionId, boards, classes, sections, loading } = this.state;

        return (
            <div className="grid w-full">
                <div className="col-4 px-2">
                    <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                        Target Board<span style={{ color: 'red' }}>*</span>
                    </label>
                    <Dropdown
                        value={boardId}
                        options={boards}
                        onChange={(e) => this.onBoardChange(e.value)}
                        placeholder="Select Board"
                        className="w-full"
                        disabled={loading || !this.props.academicYear}
                    />
                    <small className="text-muted">Single Select</small>
                </div>

                <div className="col-4 px-2">
                    <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                        Target Grade<span style={{ color: 'red' }}>*</span>
                    </label>
                    <Dropdown
                        value={classId}
                        options={classes}
                        onChange={(e) => this.onClassChange(e.value)}
                        placeholder="Select Grade"
                        className="w-full"
                        disabled={loading || !boardId}
                    />
                    <small className="text-muted">Single Select</small>
                </div>

                <div className="col-4 px-2">
                    <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                        Target Section<span style={{ color: 'red' }}>*</span>
                    </label>
                    <Dropdown
                        value={sectionId}
                        options={sections}
                        onChange={(e) => this.onSectionChange(e.value)}
                        placeholder="Select Section"
                        className="w-full"
                        disabled={loading || !classId}
                    />
                    <small className="text-muted">Single Section</small>
                </div>
            </div>
        );
    }
}

export default PromotionDropdowns;